import request from '@/utils/request'

export function listTopupOrders(params) {
  return request({
    url: '/admin/topup-orders',
    method: 'get',
    params
  })
}

export function approveTopupOrder(id) {
  return request({
    url: `/admin/topup-orders/${id}/approve`,
    method: 'put',
    data: {}
  })
}

export function rejectTopupOrder(id, reason) {
  return request({
    url: `/admin/topup-orders/${id}/reject`,
    method: 'put',
    data: { reason }
  })
}
